import api from '@pray/shared/utils/api';

export const postCommentReply = async ({ artistId, commentId, body } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!commentId) throw Error('Comment ID is required');
  if (!body) throw Error('Reply body is required');

  const url = `/web/studio/artists/${artistId}/comments/${commentId}/replies`;
  const response = await api.executePostRequest(url, { body });
  return response.data.data;
};
